import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { FilePreviewError } from '../filePreviewError';
import { useWordDocument } from 'hooks/useFileType/useWordDocument';
import { Props } from './types';
import { CONTAINER_SX, CONTENT_SX, LOADING_SX } from './styles';

export const WordDisplay: React.FC<Props> = ({ src, onDownload }) => {
  const { loading, error, htmlContent } = useWordDocument(src);

  if (error) {
    return <FilePreviewError onDownload={onDownload} />;
  }

  if (loading) {
    return (
      <Box sx={LOADING_SX}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={CONTAINER_SX}>
      <Box sx={CONTENT_SX} dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </Box>
  );
};
